<template>
  <router-link to="/" :class="className" exact>
    <BaseImage class="header-navbar__logo" :src="logoImage" />
  </router-link>
</template>

<script>
import BaseImage from '@base/BaseImage'
import Logo from './_images/logo-croplife.png'
export default {
  name: 'ElementBrand',
  components: {
    BaseImage
  },
  data () {
    return {
      className: 'brand',
      logoImage: ''
    }
  },
  created () {
    this.logoImage = Logo
  }
}
</script>

<style lang="scss">

</style>
